import { memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type MainSideNavOverlayTraySectionHeaderProps = {
  className?: string;
  headerSuffix?: ReactNode;
  headerTestId: string;
  title: string;
};

/** Section title row inside a virtualized uploads or imports list. */
export const MainSideNavOverlayTraySectionHeader = memo(
  ({ className, headerSuffix, headerTestId, title }: MainSideNavOverlayTraySectionHeaderProps) => {
    return (
      <div className={cn('pb-1.5', className)}>
        <div
          className={
            headerSuffix ? 'flex min-h-7 items-center justify-between gap-2 px-4' : 'flex min-h-7 items-center px-4'
          }
        >
          <span
            className="min-w-0 truncate font-semibold ads:text-metadata text-12 text-gray-10 tabular-nums"
            data-testid={headerTestId}
          >
            {title}
          </span>
          {headerSuffix}
        </div>
      </div>
    );
  },
);

MainSideNavOverlayTraySectionHeader.displayName = 'MainSideNavOverlayTraySectionHeader';
